/**
 * Student session, held in localStorage.
 *
 * The session lasts one day, matching the server. We keep the expiry locally
 * so the app can show the registration screen again after it lapses instead
 * of bouncing the student off a 401.
 */

const TOKEN_KEY = 'sdg.session'
const EXPIRY_KEY = 'sdg.session.expires'
/** Remembered between the form and the OTP screen, and for a resend. */
const PENDING_KEY = 'sdg.pending'

export interface PendingRegistration {
  /** The e-mail is the identity: every OTP call is keyed on it. */
  email: string
  maskedEmail: string
  resendInSeconds: number
  /** Set when signing in to an existing account rather than registering. */
  accountExists?: boolean
}

export function saveSession(token: string, expiresAt: string) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(EXPIRY_KEY, expiresAt)
}

export function getSession(): string | null {
  const token = localStorage.getItem(TOKEN_KEY)
  const expiry = localStorage.getItem(EXPIRY_KEY)
  if (!token || !expiry) return null

  if (new Date(expiry).getTime() <= Date.now()) {
    clearSession()
    return null
  }
  return token
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRY_KEY)
}

export function savePending(p: PendingRegistration) {
  localStorage.setItem(PENDING_KEY, JSON.stringify(p))
}

export function getPending(): PendingRegistration | null {
  const raw = localStorage.getItem(PENDING_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as PendingRegistration
  } catch {
    return null
  }
}

export function clearPending() {
  localStorage.removeItem(PENDING_KEY)
}
